import styled, { css } from 'styled-components';
import { IconWrapper } from '../../Icon';
import { theme } from '../../../styles/theme';

export const MainContent = styled.div`
  display: flex;
  column-gap: 4px;
  min-height: 28px;
`;

export const SecondaryContent = styled.div`
  display: flex;
  column-gap: 4px;
  justify-content: space-between;
  padding-left: 2px;
  font-size: 10px;
`;

export const ChartNameWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  column-gap: 4px;
  max-width: 100%;
`;

export const ActionsWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-left: auto;
  @media print {
    display: none;
  }
`;

const WrapperActiveStyle = css`
  background-color: ${theme.colors.blue500};
  color: ${theme.colors.mainBlue};
  border: 1px solid ${theme.colors.mainBlue};
  border-radius: 4px;
  &[data-open='true'],
  svg {
    fill: ${theme.colors.mainBlue};
  }
`;

export const ChartHeaderIconWrapper = styled(IconWrapper)<{
  $isActive?: boolean;
}>`
  & {
    :hover {
      ${WrapperActiveStyle}
    }
    ${({ $isActive }) =>
      $isActive &&
      css`
        ${WrapperActiveStyle}
      `}
  }
`;
